'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCookie = getCookie;
exports.setCookie = setCookie;

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
    path: '/'
};

/**
 * Returns value stored in cookie. If cookie does not exists, undefined is returned.
 * @param name
 */
function getCookie(name) {
    var cookies = _cookie2.default.parse(document.cookie);
    return cookies[name];
}

/**
 * Set cookie value.
 * @param name
 * @param value
 * @param options
 */
function setCookie(name, value, options) {
    var opts = (0, _assign2.default)({}, defaultOptions, options);
    document.cookie = _cookie2.default.serialize(name, value, opts);
}

exports.default = {
    getCookie: getCookie,
    setCookie: setCookie,
    defaultOptions: defaultOptions
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/cookie.js
// module id = 260
// module chunks = 0